import { HostListener, Directive, Input } from '@angular/core';

type BlockKeyboardDirectiveValues =
  | 'allowOnlyLetters'
  | 'allowOnlyNumbers'
  | 'allowOnlyDecimalNumbers'
  | 'allowBoth'
  | 'allowBothButBlockSpecialChars'
  | '';

@Directive({
  selector: '[appBlockKeyboard]',
})
export class BlockKeyboardDirective {
  @Input() public appBlockKeyboard?: BlockKeyboardDirectiveValues = '';
  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    let allowRegularKeys = [43, /*44,*/ /*45,*/ 46, 65, 66, 68];
    const specialChars = [
      33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 47, 58, 59, 60, 61, 62, 63, 64,
      91, 92, 93, 94, 95, 96, 123, 124, 125, 126,
    ];
    const charCode = event.key.charCodeAt(0);
    if (this.appBlockKeyboard === 'allowOnlyNumbers') {
      if (
        (charCode >= 48 && charCode <= 57) ||
        allowRegularKeys.includes(charCode)
      ) {
        return;
      }
    } else if (this.appBlockKeyboard === 'allowOnlyDecimalNumbers') {
      allowRegularKeys = allowRegularKeys.filter((key) => key !== 46); // 44
      if (
        (charCode >= 48 && charCode <= 57) ||
        allowRegularKeys.includes(charCode)
      ) {
        return;
      }
    } else if (this.appBlockKeyboard === 'allowOnlyLetters') {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        allowRegularKeys.includes(charCode)
      ) {
        return;
      }
    } else if (this.appBlockKeyboard === 'allowBoth') {
      return;
    } else if (this.appBlockKeyboard === 'allowBothButBlockSpecialChars') {
      if (!specialChars.includes(charCode)) {
        return;
      }
    }
    event.preventDefault();
  }
}
